module.exports = __webpack_public_path__ + "img/baseball.be5030ca.webp";